import { render, staticRenderFns } from "./AlertWarning.vue?vue&type=template&id=65700a97"
import script from "./AlertWarning.vue?vue&type=script&lang=js"
export * from "./AlertWarning.vue?vue&type=script&lang=js"
import style0 from "./AlertWarning.vue?vue&type=style&index=0&id=65700a97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports